module.exports = __webpack_public_path__ + "img/whatsapp-icon.95d0039b.svg";